import {createSelector} from '@reduxjs/toolkit'
import { combineAddress, decideLegalAndOperatingNames } from '../../app/utils'

export const populateBusinessEntityDetailsForReview = (companyRjscDetails) => {
    let businessName = "N/A"
    let legalName = "N/A"
    let rjscNumber
   

    let retObj = {
        "Legal name" : legalName,
        "Operating name" : businessName
    }

// "RJSC number" : rjscNumber,
// "RJSC status" : rjscStatus,

    let notRegistered = !companyRjscDetails?.businessEntity?.entityId;

    if(companyRjscDetails) { 
        if(companyRjscDetails.businessData?.relatedTo && companyRjscDetails.businessData?.relatedTo !== "N/A") {
            rjscNumber = companyRjscDetails.businessData.relatedTo
        }
        else if(companyRjscDetails.businessEntity?.registryNumber && companyRjscDetails.businessEntity?.registryNumber !== "N/A") {
            rjscNumber = companyRjscDetails.businessEntity.registryNumber
        }

        const {legalName, operatingName} = decideLegalAndOperatingNames(companyRjscDetails)

        retObj = {
            ...retObj,
            "Legal name" : legalName,
            "Operating name" : operatingName,
        }

        if(rjscNumber) {
            retObj["RJSC number"] = rjscNumber;
        }

        if(companyRjscDetails.businessContact && 
            companyRjscDetails.businessContact.homeJurisdictionAddress) {
            retObj["Home jurisdiction address"] = combineAddress(
                companyRjscDetails.businessContact.homeJurisdictionAddress)
        } else if(companyRjscDetails.businessContact && 
            companyRjscDetails.businessContact.civicAddress) {
            retObj["Registered office" ] = combineAddress(companyRjscDetails.businessContact.civicAddress)
        } else {
            retObj["Registered office" ] = "N/A"
        }
        
        // MRA-1433 : removing mailing address till MRA-1393 is fixed.
        // if(companyRjscDetails.businessContact &&
        //     companyRjscDetails.businessContact.mailingAddress) {
        //     retObj["Mailing address"] = combineAddress(
        //         companyRjscDetails.businessContact.mailingAddress)
        // } else {
        //     retObj["Mailing address"] = "N/A"
        // }
    
        if(companyRjscDetails.status && !notRegistered) { 
            retObj["RJSC status"] = companyRjscDetails.status
        }
    }
    
    return retObj
}

export const populateBusinessPeopleListForReview = (companyRjscDetails) => {
    let peopleReview = []

    if(companyRjscDetails) { 
        if(companyRjscDetails.businessData 
            && companyRjscDetails.businessData.peopleList
            && Array.isArray(companyRjscDetails.businessData.peopleList)) {

                const peopleNameString = (people) => { 
                    let str = []

                    if(people.firstName)
                        str.push(people.firstName)
                    
                    if(people.lastName) 
                        str.push(people.lastName)
                    
                    return str.join(" ")
                }

                companyRjscDetails.businessData.peopleList.forEach((pl) => {
                    peopleReview.push({
                        "Name" : peopleNameString(pl),
                        "Relationship" : pl.position ? pl.position : ""
                    })
                })
        }
    }

    return peopleReview
}

const rjscSearchSelector = createSelector(
    [state => state.components],
    (components) => {
        return components.rjscSearch
    }
)

export const rjscSearchSelect = state => ({
    rjscSearch: rjscSearchSelector(state)
})

const rjscDetailReviewSelector = createSelector(
    [state => state.components, 
    state => state.primaryAgencyApplication],
    (components, {application}) => {

        let companyRjscDetails = null

        if(application?.businessLicenceData?.companyRjscDetails) { 
            companyRjscDetails = application.businessLicenceData.companyRjscDetails
        }
        else if(components.rjscDetailReview?.companyRjscDetails) {
            companyRjscDetails = components.rjscDetailReview.companyRjscDetails
        }

        return Object.assign({},components.rjscDetailReview,{
            companyReview : populateBusinessEntityDetailsForReview(companyRjscDetails),
            peopleReview : populateBusinessPeopleListForReview(companyRjscDetails),
            companyRjscData : companyRjscDetails})
        }
)

export const rjscDetailReviewSelect = state => ({
    rjscDetailReview : rjscDetailReviewSelector(state)
})

const rjscSearchResultSelector = createSelector(
    [state => state.components],
    (components) => {
        const {searchResponseData, searchType} = components.rjscSearch
        return Object.assign({},components.rjscSearchResult,{searchResponseData, searchType})
    }
)

export const rjscSearchResultSelect = state => ({
    rjscSearchResult : rjscSearchResultSelector(state)
})

const rjscAdvanceSearchResultSelector = createSelector(
    [state => state.components],
    (components) => {
        const {advanceSearchResponseData, advanceSearchText} = components.rjscSearch
        return Object.assign({},
            components.rjscSearchResult,
            {advanceSearchResponseData, advanceSearchText})
    }
)

export const rjscAdvanceSearchResultSelect = state => ({
    rjscAdvanceSearchResult : rjscAdvanceSearchResultSelector(state)
})
